import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import RequestItemHeaders from './RequestItemHeaders';
import RequestItem from './RequestItem';

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
  },
}));

const RequestItemList = ({requests}) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <RequestItemHeaders />
      {requests.map(r =>
        <RequestItem
          key={r.short_id}
          requestId={r.short_id}
          status={r.status}
          createdAt={r.created_at}
          updatedAt={r.updated_at}
          detail={r.detail}
        />
      )}
    </div>
  );
};

RequestItemList.propTypes = {
  requests: PropTypes.array.isRequired,
};

export default RequestItemList;
